var exports = {
  "AS": "xa15a2ab7--6eae49--item",
  "nf": "xa15a2ab7--6eae49--link",
  "Gq": "xa15a2ab7--6eae49--image_block",
  "Sl": "xa15a2ab7--6eae49--image",
  "Ex": "xa15a2ab7--6eae49--content_block",
  "q9": "xa15a2ab7--6eae49--price",
  "DD": "xa15a2ab7--6eae49--title",
  "hl": "xa15a2ab7--6eae49--address",
  "se": "xa15a2ab7--6eae49--address_two_rows",
  "$k": "xa15a2ab7--6eae49--address_one_row",
  "gO": "xa15a2ab7--6eae49--ellipsis",
  "w4": "xa15a2ab7--6eae49--photo_label",
};

module.exports = exports;
